import { http } from 'app';

export const getAssuranceReportDraftingDoc = async (
  businessArea: string,
  service: string,
  body: any
): Promise<{ file: any; fileName: string; fileType: string }> => {
  const DEFAULT_FILE_NAME = 'Assurance_Report_Drafting_ToR.docx';
  const DEFAULT_FILE_TYPE = 'application/msword';

  try {
    const response = await http.post(
      '/:businessArea/:service'
        .replace(':businessArea', businessArea)
        .replace(':service', service),
      body,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
        responseType: 'arraybuffer'
      }
    );

    const contentDisposition = response?.headers['content-disposition'];
    const fileType =
      (response?.headers['content-type'] as string) || DEFAULT_FILE_TYPE;

    const matches = contentDisposition?.includes('filename=')
      ? contentDisposition.match(/filename="([^"]+)"/)
      : null;
    const fileName = matches?.[1] || DEFAULT_FILE_NAME;

    return { file: response.data, fileName, fileType };
  } catch (error: any) {
    const parseErrorMessage = (data: any): string | undefined => {
      if (data instanceof ArrayBuffer) {
        try {
          const text = new TextDecoder().decode(data);
          const parsed = JSON.parse(text);
          return parsed.message;
        } catch {
          return undefined;
        }
      }
      return data?.message;
    };

    const getStatusCode = (data: any): number | undefined => {
      if (data instanceof ArrayBuffer) {
        try {
          const text = new TextDecoder().decode(data);
          const parsed = JSON.parse(text);
          return parsed.statusCode;
        } catch {
          return undefined;
        }
      }
      return data?.statusCode;
    };

    const statusCode = getStatusCode(error.response?.data);

    if (statusCode === 422) {
      const newBody = body;
      newBody.set('ignoreCache', true);
      try {
        const response = await http.post(
          '/:businessArea/:service'
            .replace(':businessArea', businessArea)
            .replace(':service', service),
          newBody,
          {
            headers: { 'Content-Type': 'multipart/form-data' }
          }
        );

        const contentDisposition = response?.headers['content-disposition'];
        const fileType =
          (response?.headers['content-type'] as string) || DEFAULT_FILE_TYPE;

        const matches = contentDisposition?.includes('filename=')
          ? contentDisposition.match(/filename="([^"]+)"/)
          : null;
        const fileName = matches?.[1] || DEFAULT_FILE_NAME;
        return { file: response.data, fileName, fileType };
      } catch (retryError: any) {
        const errorMessage = parseErrorMessage(retryError.response?.data);
        throw new Error(errorMessage || 'Failed to generate report');
      }
    } else {
      const errorMessage = parseErrorMessage(error.response?.data);
      throw new Error(errorMessage || 'Failed to generate report');
    }
  }
};
